<!--空布局:
遵循easycom规范, 可作为独立的组件, 不使用mescroll的页面也能使用:
<mescroll-empty v-if="isShowEmpty" :option="optEmpty" @emptyclick="emptyClick"></mescroll-empty>
-->
<template>
	<div class="mescroll-empty" :class="{ 'empty-fixed': option.fixed }" :style="{ 'z-index': option.zIndex, top: option.top }">
		<div> <img v-if="icon" class="empty-icon" src="../static/img/null.png" mode="widthFix" /> </div>
		<div v-if="tip" class="empty-tip">{{ tip }}</div>
		<div v-if="btnText" class="empty-btn" @click="emptyClick">{{ btnText }}</div>
	</div>
</template>

<script>
export default {
  props: {
    // empty的配置项: 默认为GlobalOption.up.empty
    option: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  // 使用computed获取配置,用于支持option的动态配置
  computed: {
    // 图标
    icon () {
      if (this.option.icon != null) { // 此处不使用短路求值, 用于支持传空串不显示图标
        return this.option.icon
      }
    },
    // 文本提示
    tip () {
      if (this.option.tip != null) { // 支持传空串不显示文本提示
        return this.option.tip
      }
    },
    // 按钮文本
    btnText () {
      return this.option.btnText
    }
  },
  methods: {
    // 点击按钮
    emptyClick () {
      this.$emit('emptyclick')
    }
  }
}
</script>

<style>
/* 无任何数据的空布局 */
.mescroll-empty {
	box-sizing: border-box;
	width: 100%;
	padding: 50px 25px;
	text-align: center;
}

.mescroll-empty.empty-fixed {
	z-index: 99;
	position: absolute; /*transform会使fixed失效,最终会降级为absolute */
	top: 50px;
	left: 0;
}

.mescroll-empty .empty-icon {
	/* width: 140px;
	height: 140px; */
}

.mescroll-empty .empty-tip {
	margin-top: 10px;
	font-size: 12px;
	color: gray;
}

.mescroll-empty .empty-btn {
	display: inline-block;
	margin-top: 20px;
	min-width: 100px;
	padding: 9px;
	font-size: 14px;
	border: 0.5px solid #e04b28;
	border-radius: 30px;
	color: #e04b28;
}

.mescroll-empty .empty-btn:active {
	opacity: 0.75;
}
</style>



// WEBPACK FOOTER //
// packages/appletView/src/components/mescrollEmpty.vue